module.exports = __webpack_public_path__ + "img/Create-your-Calming-Sanctuary.1a74e4ec.png";